//import liraries
import React, { Component, useEffect, useState } from "react";
import { View, Text, StyleSheet, TouchableOpacity, ScrollView } from "react-native";
import { cancelTIPolicy } from "../../api/tripInsurance";
import CustomButton from "../../common/CustomButton";
import CustomInput from "../../common/CustomInput";
import CCheckbox from "../../common/CCheckBox";
import CHeader from "../../common/CHeader";
import CImage from "../../common/CImage";
import CText from "../../common/CText";
import MainContainer from "../../common/CWrapper";
import ModalAlert from "../../common/ModalAlert";
import Loader from "../../common/Loader";
import CDocxViewer from "../../common/CDocxViewer";


import useStyles from "./CancelTripInsurance_Styles";

// create a component
const CancelTripInsurance = (props) => {
  const styles = useStyles();
  const [loading, setLoading] = useState(false);
  const [reason, setReason] = useState("");
  const [isChecked, setIsChecked] = useState(false);
  const [alertModalVisible, setAlertModalVisible] = useState(false);
  const [tncModalVisible, setTncModalVisible] = useState(false);
  const [alertModal, setAlertModal] = useState({
    title: "",
    status: "",
    message: "",
    navigateScreen: "",
    navigate: "",
    actionButton: "",
  });

  const onCloseModal = () => {
    setAlertModalVisible(false);
    if (alertModal.navigate == "Dashboard") props.navigation.navigate("Home");
  };
  let cancelPlanTitle = "";
  let cancelPlanDesc = "";
  let isCancelPolicy = false;
  let insuranceType = "";
  let buttonTitle = "";

  if (props?.data?.policyData && props?.data?.policyData?.recurringPolicyOpted?.planId) {
      cancelPlanTitle =
        `Are you sure you want to Opt-out from ${props?.data?.policyData?.recurringPolicyOpted?.planName} ?`;
      cancelPlanDesc =
        "By clicking on opt-out you agree that you will not be insured henceforth. Though you are not eligible for any refund, the policy shall remain active for the applicable period.";
      isCancelPolicy = true;
      insuranceType = "ti24R";
      buttonTitle = "Opt-Out";
  } else if (
    props?.data?.policyData?.activePolicy?.coiNo &&
    props?.data?.policyData?.activePolicy?.planName.includes("Annual")
  ) {
    cancelPlanTitle = `Are you sure you want to cancel ${props?.data?.policyData?.activePolicy?.planName}?`;
    cancelPlanDesc =
      "The applicable refund amount will be credited to your FASTag wallet in 3-5 business days.";
    isCancelPolicy = true;
    insuranceType = "tiAnnual";
    buttonTitle = "Cancel Insurance";
  } else if (
    props?.data?.policyData?.activePolicy?.coiNo &&
    props?.data?.policyData?.activePolicy
  ) {
    cancelPlanTitle = "Request cannot be processed";
    cancelPlanDesc =
      `Sorry, as per the applicable T&C, ${props?.data?.policyData?.activePolicy?.planName} cannot be cancelled once activated. Though you are not eligible for any refund, the policy shall remain active for the applicable period.`;
    isCancelPolicy = false;
    insuranceType = "ti24S";
    buttonTitle = "Back";
  }

  const cancelPolicy = () => {
    setLoading(true);
    let reqObj = {
      COINo: props?.data?.policyData?.activePolicy?.coiNo || "",
      reason: reason,
    };
    cancelTIPolicy(reqObj)
      .then((res) => {
        if (res.statusCode == 200 || res.statusCode == 1093) {
          setLoading(false);
          setAlertModal({
            title: "Success",
            status: "success",
            message: res.message,
            navigateScreen: "",
            actionButton: "OK",
          });
          setAlertModalVisible(true);
          props.setScreen("home")
        } else {
          setLoading(false);
          setAlertModal({
            title: "Error",
            status: "error",
            message: res.message,
            navigateScreen: "",
            actionButton: "OK",
          });
          setAlertModalVisible(true);
        }
      })
      .catch((err) => {
        setLoading(false);
        setAlertModal({
          title: "Error",
          status: "error",
          message: err.message,
          navigateScreen: "",
          actionButton: "OK",
        });
        setAlertModalVisible(true);
      });
  };


  return (
    <MainContainer>
      <View style={styles.contentWrapper}>
        <CHeader
        showBack
          disputeHeader
          title="Cancel Trip Insurance"
          onPress={() => props.setScreen(props.info.backNavigation)}
          showDesc={true}
        />
        <View style={styles.contentViewStyle}>
          <View
            style={styles.firstViewStyle}
          >
            <CImage.cancelPolicyIcon />
            <CText.cancelPolicyConfirmText
              style={{ textAlign: "center", paddingVertical: 20 }}
            >
              {cancelPlanTitle}
            </CText.cancelPolicyConfirmText>
            <CText.headerDesc style={{ textAlign: "center" }}>
              {cancelPlanDesc}
            </CText.headerDesc>
          </View>
          <View
            style={[styles.secondViewStyle,{
              alignItems: insuranceType == "ti24S" ? "center" : null,
            }]}
          >
            {(insuranceType == "ti24R" || insuranceType == "tiAnnual") && 
            (
                <CustomInput
                  label={"Reason for cancellation"}
                  value={reason}
                  onValueChanged={(t) => setReason(t)}
                  flexDirection={"column"}
                  multiline={true}
                  style={styles.textInputStyle}
                />
              )}
              {
                insuranceType == "ti24S"
                &&  <CImage.Ti24SCancelImage />
              }
              <TouchableOpacity onPress={() => setTncModalVisible(true)}>
            <CText.cancelPolicyConfirmText
              style={{
                alignSelf: insuranceType == "ti24S" ? "center" : "flex-start",
                paddingVertical:insuranceType == "ti24S" ? 40 : 20,
                opacity: 1,
                fontSize: 12,
                textDecoration: "underline",
              }}
            >
              {"Read Terms and Conditions"}
            </CText.cancelPolicyConfirmText>
            </TouchableOpacity>
            {(insuranceType == "ti24R" ||
              insuranceType == "tiAnnual")&& (
                <View>
                  <CCheckbox
                    termsText={`I Agree to the terms and conditions`}
                    setIsTermsChecked={setIsChecked}
                    isTermsChecked={isChecked}
                    textDecorationLine={"none"}
                    backgroundColor={"#bd2d37"}
                    textColor={"#212121"}
                  />
                </View>
              )}

            {insuranceType == "ti24S" ? (
              <View style={styles.btnTopWrapper}>
                <CustomButton
                  text={buttonTitle}
                  onPress={() => props.setScreen("home")}
                />
              </View>
            ) : (
              <View style={styles.buttonContainerStyle}>
                <CustomButton onPress={() => props.setScreen("home")} skipButton text={"Back"} />
                <View style={styles.btnWrapper}>
                  <CustomButton
                    disable={!isChecked || reason == "" ? true : false}
                    text={buttonTitle}
                    onPress={
                      !isChecked || reason == "" ? "" : () => cancelPolicy()
                    }
                  />
                </View>
              </View>
            )}
          </View>
        </View>
      </View>

      {alertModalVisible && (
        <View style={styles.overlayViewStyle}>
          <ModalAlert
            title={alertModal.title}
            status={alertModal.status}
            message={alertModal.message}
            navigateScreen={alertModal.navigateScreen}
            actionButton={"OK"}
            onCloseModal={onCloseModal}
          />
        </View>
      )}
       {tncModalVisible &&  <CDocxViewer visibility={setTncModalVisible} type = "FF_TRIP_TNC" />}
      {loading && <Loader />}
    </MainContainer>
  );
};


//make this component available to the app
export default CancelTripInsurance;
